import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { ArrowRight, Lock } from "lucide-react";
import { toast } from "sonner";

export default function BuyerLogin() {
  const { loginBuyer } = useApp();
  const nav = useNavigate();
  const [form, setForm] = useState({ mobile: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.mobile || !form.password) { toast.error("Fill all fields"); return; }
    setBusy(true);
    try {
      const buyer = await loginBuyer(form);
      toast.success(`Welcome, ${buyer.person_name || buyer.name}`);
      nav("/catalog");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid grid-cols-1 lg:grid-cols-2" data-testid="buyer-login-page">
      <div className="hidden lg:block bg-[#1E2C5A] relative">
        <div className="absolute inset-0 flex flex-col justify-between p-14 text-white">
          <p className="label-eyebrow !text-white/50">TileRoom · Trade Portal</p>
          <div>
            <h2 className="font-editorial text-5xl leading-tight">
              A trade catalogue<br/>reserved for our<br/><em className="italic text-[#C9A968]">partners.</em>
            </h2>
            <p className="text-white/60 text-sm mt-6 max-w-md">
              Access dedicated support and priority.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md">
          <div className="w-10 h-10 bg-[#C9A968] flex items-center justify-center mb-6">
            <Lock className="w-4 h-4 text-[#1E2C5A]" strokeWidth={2} />
          </div>
          <p className="label-eyebrow">Sign In</p>
          <h1 className="font-editorial text-5xl tracking-editorial mt-3 mb-2">Welcome back</h1>
          <p className="text-sm text-[#5C5C5C] mb-10">Enter your registered mobile number and password.</p>

          <form onSubmit={submit} className="space-y-6" data-testid="buyer-login-form">
            <div>
              <label className="label-eyebrow block mb-1">Mobile Number</label>
              <input className="input-editorial" value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} placeholder="+91 98xxxx xxxxx" data-testid="login-mobile" />
            </div>
            <div>
              <label className="label-eyebrow block mb-1">Password</label>
              <input type="password" className="input-editorial" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="••••••••" data-testid="login-password" />
            </div>
            <div className="flex items-center justify-between text-xs">
              <Link to="/forgot-password" className="link-slide text-[#1E2C5A]" data-testid="link-forgot">Forgot password?</Link>
              <Link to="/signup" className="link-slide text-[#1E2C5A]" data-testid="link-signup">Create account →</Link>
            </div>
            <p className="text-center text-xs uppercase tracking-[0.2em] text-[#C9A968] py-3 border-t border-b border-[#C9A968]/30" data-testid="architect-cta">
              Ask your architect / interior to sign up today
            </p>
            <button type="submit" disabled={busy} className="btn-clay w-full" data-testid="login-submit">
              {busy ? "Signing in..." : "Sign In"} <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
